export default __webpack_public_path__ + "assets/images/Check-462f0ebe8f0f086216b85e60f6ed1307.svg";